import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../components/Header.js";
import icon from "../images/icone_ambiente_seguro.svg";

export class Terms extends Component {
  handleClick(param) {
    this.props.onAccept({ accept: param });
  }

  render() {
    return (
      <div className="container">
        <Header logo={this.props.logo} />
        <div className="row" style={{ minHeight: "calc(100vh - 100px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2">
            <div className="card h-100">
              <img src={icon} style={{ height: "100px" }} className="img-fluid mx-auto d-block mt-4" alt="" />
              <div className="card-body text-center px-4 mb-5">
                <h4 className="card-title fw-bold text-primary">AMBIENTE SEGURO</h4>
                <div className="border-top my-2 "></div>
                {this.props.termsUpdate && <h5 className="card-title fw-bold text-primary">ESTE É UM AMBIENTE SEGURO</h5>}
                <h5 className="card-text text-secondary mt-4">
                  {!this.props.termsUpdate ? `ESTE É UM AMBIENTE SEGURO` : "Informamos que nossos termos de uso e política de privacidade foram atualizados."}
                  <br />
                </h5>
                <h6 className="card-text text-secondary mt-sm-5">
                  Ao CLICAR em CONCORDO, você aceita os{" "}
                  <a href={this.props.termsURL} target="_blank" style={{ textDecoration: "none", color: "unset" }} rel="noreferrer">
                    termos de uso e aviso de privacidade
                  </a>{" "}
                  e tem ciência que seus dados pessoais serão tratados pelo ON-RCPN para viabilizar seu cadastro.
                </h6>
                <h6 className="card-text text-secondary mt-sm-5 mb-5">
                  Caso não queira usar a biometria, clique no 'X' no canto superior direito para outras opções de login. Ao escolher essas opções, informamos que alguns serviços que exigem biometria
                  podem não estar disponíveis.
                </h6>
              </div>
              <div className="fixed-button-container">
                <div className="row justify-content-center">
                  {/* {<div className="col-4 d-grid">
                    <button className="btn btn-secondary w-100 fw-bold" type="button" onClick={() => this.handleClick(0)}>
                      SAIR
                    </button>
                  </div>} */}
                  <div className="col-8 d-grid">
                    <button className="btn btn-primary w-100 fw-bold" type="button" onClick={() => this.handleClick(1)}>
                      CONCORDO
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Terms.propTypes = {
  onAccept: PropTypes.func.isRequired,
  termsUpdate: PropTypes.bool,
  termsURL: PropTypes.string.isRequired,
  sigla: PropTypes.string.isRequired,
};

export default Terms;
